module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-select mt-font--body10 mt--neutrals-dark-gray-02",
    class: _vm.isDropdown ? 'mt-select--open' : '',
    style: ({
      width: _vm.width + 'px'
    })
  }, [_c('mt-input', {
    attrs: {
      "value": _vm.selectedValue,
      "label": _vm.label,
      "name": "icon",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "icon": "chevron-down",
      "clearble": _vm.clearble
    },
    on: {
      "click": _vm.handleClickIcon,
      "update:value": function($event) {
        _vm.selectedValue = $event
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "mt-select__options mt-font--body10",
    style: (_vm.optionStyles)
  }, _vm._l((_vm.filteredOptions), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "mt--neutrals-dark-gray-02",
      class: {
        'selected': _vm.getValueOfItem(item) === _vm.selectedValue
      },
      on: {
        "click": function($event) {
          _vm.handleClickOption(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.getLabelOfItem(item)) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32443e4b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/select/Select.vue
// module id = QVSK
// module chunks = 0